import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BusinessProvider } from "./context/BusinessContext";
import Layout from "./components/Layout";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import Ledger from "./pages/Ledger";
import Categories from "./pages/Categories";
import Reports from "./pages/Reports";
import Contact from "./pages/Contact";
import Businesses from "./pages/Businesses";
import Admin from "./pages/Admin";
import Staff from "./pages/Staff";

function Loading() {
  return <div className="flex min-h-screen items-center justify-center text-slate-500">Yükleniyor…</div>;
}

function Protected() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/giris" replace />;
  return <Layout />;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/" replace /> : children;
}

function App() {
  return (
    <AuthProvider>
      <BusinessProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<PublicOnly><AuthPage mode="login" /></PublicOnly>} />
            <Route path="/kayit" element={<PublicOnly><AuthPage mode="register" /></PublicOnly>} />
            <Route element={<Protected />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/defter" element={<Ledger />} />
              <Route path="/kategoriler" element={<Categories />} />
              <Route path="/personel" element={<Staff />} />
              <Route path="/raporlar" element={<Reports />} />
              <Route path="/isletmeler" element={<Businesses />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </BusinessProvider>
    </AuthProvider>
  );
}

export default App;
